import React, { useState, Suspense, useEffect, useRef } from 'react'
import Oval from 'react-loading-icons/dist/esm/components/oval';
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData, useNavigate } from 'react-router-dom';
import { getAllUsersPaged, getCompanyUserList, UserPowerSearch, } from '../../Api Methods/Api';
import UsersGrid from '../../components/GridList/UsersGrid';
import FilterSearch from '../../components/PowerSearch/PowerSearch';
import FilterUsersSearch from '../../components/PowerSearch/FilterUsersSearch';

import classes from "./UserManagementPage.module.css"
import UserList from './UserManagementList';
import GridPaginationControls from '../../components/Table/Table/GridPaginationControls';
import DataManager from '../../hooks/DataManager';
import Stats2 from '../../components/UI/Stats/Stats2';
import Button2 from '../../components/UI/Button/Button2';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/CustomDropDown/Input/Input';
import CreateUserForm from './CreateUserForm';
import FullAccountRegistration from '../../Register/fullAccountRegistration';
import CreateUser from '../../Register/CreateUser';

import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import wait from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import { Dropdown } from 'primereact/dropdown';
import { useBreakpointValue } from 'rsuite';
import MassCreateUserForm from '../../components/forms/MassCreateUserForm';
import Lottie from 'lottie-react';
import { Button } from 'primereact/button';
import loadingAnim from '../../assets/animations/newLoading.json'
import successAnim from '../../assets/animations/success.json'
import mixpanel from 'mixpanel-browser';
import { set } from 'date-fns';
import { se } from 'date-fns/locale';

const UserManagementPageCardGrid = () => {

  const dataManager = new DataManager();
  const [filteredResults, setFilteredResults] = useState([]);
  const [resultCount, setResultCount] = useState(0)
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);

  const [success, setSuccess] = useState(false)
    const [massSuccess, setMassSuccess] = useState(false)
  const [fail, setFail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("Processing file...")
  const [countProcessed, setCountProcessed] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [reason, setReason] = useState("")
  const [newUserEmail, setNewUserEmail] = useState("")
  const navigate = useNavigate();

  const [successMessage, setSuccessMessage] = useState("")

  const dispatch = useDispatch();
  const apiData = {
    token,
    client
  }

  const [pageSize, setPageSize] = useState(100);
  const [pageOffset, setPageOffset] = useState(0)
  const [pageNumber, setPageNumber] = useState((dataManager.getItem('usersPageNumber')) || 1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState();
  const [reset, setReset] = useState(0)




  const [modalComponent, setModalComponent] = useState(null)
  const ModalDialog = useRef();

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const HandleCloseModal = () => {
    ModalDialog.current.close();
  }

  const userEmailRef = useRef();
  const userPincodeRef = useRef();

  const prevSearch = useRef();
  const [userEmailAddress, setUserEmailAddress] = useState("")
  const [userPassword, setUserPassword] = useState("")

  useEffect(() => {

    mixpanel.track("Users tab visited", {
      user: localStorage.getItem('email')
    });
  }, [])

  /*
  //Fetch all users on mount
  useEffect(() => {
    const GetAllUsersPaged = async () => {
      const response = await getAllUsersPaged(apiData, pageSize, pageNumber, dispatch);
      console.log(response)
      setFilteredResults(response[0].users)
      setResultCount(response[0].users.length)
      console.log(response[0].users.length)
      setTotalUsers(response[0].totalUsers)
      setStatsLoading(false)
      if (dataManager.getItem('userSearchQuery') == "") {
        setIsLoading(false)
      }

      setTotalPages(Math.round(totalUsers / pageSize));
    }

    GetAllUsersPaged();
  }, [pageSize, pageNumber, reset])
  */

  const HandleNextPage = () => {
    setPageNumber(prevPageNumber => pageNumber + 1)
    setPageOffset(prevPageOffset => prevPageOffset + pageSize)
    dataManager.setItem('usersPageNumber', pageNumber + 1)
  }

  const HandlePreviousPage = () => {
    setPageNumber(prevPageNumber => pageNumber - 1)
    setPageOffset(prevPageOffset => prevPageOffset - pageSize)
    dataManager.setItem('usersPageNumber', pageNumber - 1)
  }

  const [searchQuery, setSearchQuery] = useState(dataManager.getItem('userSearchQuery') || '');
  const [portalAdmin, setPortalAdmin] = useState(0)
  const [appAdmin, setAppAdmin] = useState(0)

  const [isLoading, setIsLoading] = useState(true)
  const [statsLoading, setStatsLoading] = useState(true)

  useEffect(() => {
    const getUsers = async () => {
      const newOffset = (pageNumber - 1) * pageSize; 
      const body = {
        "query": searchQuery || "%",
        "portalAdmin": portalAdmin,
        "appAdmin": appAdmin,
        "pageSize": pageSize,
        "pageOffset": newOffset
      }

      const response = await UserPowerSearch(apiData, body, dispatch);
      const users = response[0].users;
      const totalUsers = response[0].totalCount.resultCount;

      setFilteredResults(users);
      setTotalUsers(totalUsers);
      setIsLoading(false);
      setStatsLoading(false);

      setTotalPages(Math.ceil(totalUsers / pageSize));

    };
    getUsers();
  }, [searchQuery, pageSize, pageNumber, reset, appAdmin, portalAdmin]);

  useEffect(() => {
    dataManager.setItem('userSearchQuery', searchQuery)

    const timer = setTimeout(() => {
      if (searchQuery && (searchQuery !== prevSearch.current)) {
          mixpanel.track("Users tabs search performed", {
              user: localStorage.getItem('email'),
              searchTerm: searchQuery
          });
      }
      prevSearch.current = searchQuery;
    }, 2000);
    return () => clearTimeout(timer); 

  }, [searchQuery])

  const handleFilterLogic = async (data, searchQuery, selectedCategories) => {
    const users = await data;
    setFilteredResults(users);
    setIsLoading(false)
  };

  const submitHandler = async () => {
    HandleCloseModal()
  }

  useEffect(() => {

    if (success) {
      setSuccess(false)
      successPopup()
    }

    if (massSuccess){
      setMassSuccess(false)
      massSuccessPopup()
    }

    if (fail) {
      setFail(false)
      failPopup()
    }

    if (loading){
      setLoading(false)
      loadingPopup()
    }
  }, [success, fail, loading, massSuccess])

  const HandleViewUser = async () => {
    if (newUserEmail !== ""){
    const body = {
            "query": newUserEmail || "",
            "portalAdmin": 0,
            "appAdmin": 0,
            "pageSize": 20,
            "pageOffset": 0
        }
    
        const userResponse = await UserPowerSearch(apiData, body, dispatch);        
        const user = userResponse[0].users[0]
        console.log(user)

        dataManager.setItem('clickedUserObj', user)
        dataManager.setItem('clickedUserEmailAddress', user.email)
        dataManager.setItem('clickedUserID', user.id)
        navigate('/Dashboard/Users/UserSites')
    }
  }

  const successPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>User created!</h3>
          <br></br>
          <h3 style={{ textAlign: "center", color: "#858585" }}>What would you like to do next?</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleViewUser} style={{ width: "100%" }}>View user</Button1>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

    const massSuccessPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Lottie
            animationData={successAnim}
            loop={false}
            style={{ width: 250, height: 250, margin: "0px" }}
          />
        
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{`${totalCount} users created successfully!`}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

  const failPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={cross}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>Failed to create user!</h3>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{reason}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

  const loadingPopup = () => {
    setModalComponent(
     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <h3 style={{ color: "#6e6e6eff" }}>Please wait...</h3>
          <p style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center", fontSize:"18px", fontWeight:600 }}>{`Created ${countProcessed} of ${totalCount} accounts`}</p>
          <Lottie
            animationData={loadingAnim}
            loop={true}
            style={{ width: 250, height: 250, margin: "0px" }}
          />

          <p style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center", fontSize:"18px", fontWeight:600 }}>{successMessage}</p>
          <br/>
          <Button label="Cancel" icon="pi pi-times" rounded severity="primary" onClick={() => HandleCloseModal()} />
        </div>
    )

    HandleShowModal();
  }

  useEffect(() => {
    if (successMessage != "" && countProcessed > 0){
      loadingPopup();
    }
    
  }, [successMessage, countProcessed])

  const options = [
    "Create single user",
    "Create multiple users"
  ]

  

  const showCreateUserForm = () => {
    setModalComponent(
      <CreateUser
        HandleCloseModal={HandleCloseModal}
        setSuccess={setSuccess}
        setFail={setFail}
        setReason={setReason}
        setNewUserEmail={setNewUserEmail}
        apiData={apiData}
      />
    )
    HandleShowModal();
  };

  const showMassCreateUserForm = () => {
    setModalComponent(
      <MassCreateUserForm
        setSuccess={setMassSuccess}
        setFail={setFail}
        setLoading={setLoading}
        countProcessed={countProcessed}
        setCountProcessed={setCountProcessed}
        setTotalCount={setTotalCount}
        apiData={apiData}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
    )
    HandleShowModal();
  };

  useEffect(() => {
    console.log(countProcessed)
  }, [countProcessed])

  const setSelectedOption = (option) => {
    switch (option){
      case "Create single user":
        showCreateUserForm()
        break;
      case "Create multiple users":
        showMassCreateUserForm()
        break;
    }
  }

  return (
    <>
      <Modal ref={ModalDialog} title={"Create user"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
        {modalComponent}
      </Modal>

      <div className={classes['userManagementPage_container']}>
        <Await resolve={totalUsers}>
          {(loadedTotalUsers) =>
            <div style={{ display: "flex", width: "100%" }}>
              <Stats2 title={"Total active users"} value={loadedTotalUsers} isLoadingStats={statsLoading} isStatic={true} />
            </div>
          }
        </Await>


        <div className={classes.searchRowContainer}>
          <FilterUsersSearch
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            placeholder="Start typing to search users..."
            setIsLoading={setIsLoading}
            setFilteredResults={setFilteredResults}
            handleFilterLogic={handleFilterLogic}
            categories={["Online", "Offline", "Notifications On", "Notifications Off", "Favorited", "Not Favorited"]}
            reset={reset}
            setReset={setReset}
            portalAdmin={portalAdmin}
            setPortalAdmin={setPortalAdmin}
            appAdmin={appAdmin}
            setAppAdmin={setAppAdmin}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageOffset={pageOffset}
            setPageOffset={setPageOffset}
          />



          <Dropdown 
            onChange={(e) => setSelectedOption(e.value)} 
            options={options} 
            placeholder="Create user(s)" 
            className={`${classes.dropdown} w-full md:w-14rem`} 
          />
        </div>



        <Suspense
          fallback={
            <div className={classes["loadingSpinner-container"]}>
            </div>
          }>
          <Await resolve={filteredResults}>

            {(loadedFilteredResults) =>
              <div>
                <div style={{ display: "flex", width: "100%" }}>
                  <UserList data={loadedFilteredResults} setData={setFilteredResults} apiData={apiData} searchQuery={searchQuery} isLoading={isLoading} setIsLoading={setIsLoading} />
                </div>
                <br></br>
                <div>
                  <GridPaginationControls
                    pageIndex={pageNumber}
                    nextPage={HandleNextPage}
                    previousPage={HandlePreviousPage}
                    setPageIndex={setPageNumber}
                    pageCount={totalPages}
                    setPageSize={setPageSize}
                    PageSize={pageSize}
                    totalDevices={totalUsers} //Total user count
                    setTotalDevices={setTotalUsers} //set total user count
                  />
                </div>
              </div>
            }
          </Await>
        </Suspense>
      </div>
    </>
  )
}

export default UserManagementPageCardGrid

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');
  const companyName = localStorage.getItem('companyName');

  const apiData = {
    token,
    client
  }

  return defer({
    // portalUsers: getCompanyUserList(apiData, companyName),
  })
}
